import { useState } from 'react';

export function Avatar({ src, name, size = 36 }: { src: string | null; name: string | null; size?: number }) {
  const [failed, setFailed] = useState(false);
  const initial = (name?.trim()[0] || '?').toUpperCase();
  return (
    <span className="avatar" style={{ width: size, height: size }} aria-hidden="true">
      {src && !failed
        ? <img src={src} alt="" width={size} height={size} loading="lazy" referrerPolicy="no-referrer" onError={() => setFailed(true)} />
        : initial}
    </span>
  );
}
